import { createAsyncThunk, createDraftSafeSelector, createSlice } from "@reduxjs/toolkit";
import { FS } from "src/configs/constance";
import heuristicVaultsConfig from "src/configs/heuristic-vaults";
import FramingQuery from "src/utils/query/onchain/multi-call-query/framing-query";

export const fetchAllVaultsData = createAsyncThunk("heuristicFarmingSlice/fetchAllVaultsData", async (_, thunkAPI) => {
  await Promise.all(
    Object.entries(heuristicVaultsConfig).map(([vaultId, _]) => thunkAPI.dispatch(fetchVaultData({ vaultId })))
  );
});

export const fetchVaultData = createAsyncThunk(
  "heuristicFarmingSlice/fetchVaultData",
  async ({ vaultId }, thunkAPI) => {
    const accountAddress = thunkAPI.getState().accountSlice.address;
    return await FramingQuery.fetchHeuristicVault(vaultId, accountAddress);
  }
);

const initialState = {
  vaults: {},
  fetchingStatus: FS.INITIAL,
};

const heuristicFarmingSlice = createSlice({
  name: "heuristicFarmingSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchAllVaultsData.pending, (state, _) => {
        state.fetchingStatus = FS.FETCHING;
      })
      .addCase(fetchAllVaultsData.rejected, (state, action) => {
        state.fetchingStatus = FS.FAIL;
        console.error(action);
      })
      .addCase(fetchAllVaultsData.fulfilled, (state) => {
        state.fetchingStatus = FS.SUCCESS;
      })
      .addCase(fetchVaultData.fulfilled, (state, action) => {
        const vaultId = action.meta.arg.vaultId;
        state.vaults[vaultId] = { ...state.vaults[vaultId], ...action.payload };
      })
      .addCase(fetchVaultData.rejected, (state, action) => {
        console.error(action);
      }),
});

export default heuristicFarmingSlice.reducer;

export const selectHeuristicFarmingSlice = (state) => state.heuristicFarmingSlice;

export const selectAllVaults = createDraftSafeSelector(
  (state) => selectHeuristicFarmingSlice(state).vaults,
  (vaults) => {
    if (!vaults) return [];
    const res = Object.entries(vaults).map(([_, item]) => item);
    res.sort((v1, v2) => v1.level - v2.level);
    return res;
  }
);
